import { render, staticRenderFns } from "./Objects.vue?vue&type=template&id=9dc8e5ee&scoped=true&lang=html&"
import script from "./Objects.vue?vue&type=script&lang=js&"
export * from "./Objects.vue?vue&type=script&lang=js&"
import style0 from "./Objects.vue?vue&type=style&index=0&id=9dc8e5ee&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc8e5ee",
  null
  
)

export default component.exports